// Libs
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import { Box, Button, Stack, Typography } from '@mui/material';
// Components, Layouts, Pages
// Others
import { IFile } from '~/utils/interface/common';
import { IInventoryDetail } from '~/utils/interface/inventory';
import { formatFileSize, getFileNameFromUri, getTypeFileFromUri } from '~/utils/helper/common';
// Styles, images, icons
import styles from './DocumentProductDetail.module.scss';
import { icons } from '~/assets';

type Props = {
  detailProduct?: IInventoryDetail;
};

const cx = classNames.bind(styles);

const DocumentProductDetail = (props: Props) => {
  //#region Destructuring Props
  const { detailProduct } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/inventory', 'common/base']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  const renderItemDocument = (item: IFile, index: number) => {
    return (
      <Stack key={index} className={cx('itemDocument')}>
        <Stack gap={4} direction={'row'} alignItems={'center'}>
          <Box className={cx('bgIcon')}>
            <img src={icons.commonIconFileDocument} alt={t('altImg', { ns: 'common/base' })} />
          </Box>

          <Box>
            <Typography className={cx('label')}>{getFileNameFromUri(item.name)}</Typography>
            <Typography className={cx('value')}>{`${getTypeFileFromUri(item.name)} - ${formatFileSize(
              item.size
            )}`}</Typography>
          </Box>
        </Stack>

        <Button onClick={() => handleDownLoad(item)}>
          <Typography className={cx('textDownload')}>{t('common_text_download', { ns: 'common/base' })}</Typography>
        </Button>
      </Stack>
    );
  };

  const handleDownLoad = (item: IFile) => {
    window.open(item.url);
  };
  //#endregion Handle Function

  return (
    <Stack id='documentProductDetailComponent' gap={6} className={cx('container')}>
      <Typography className={cx('textHeader')}>{t('inventory_detail_title_documentation_attachments')}</Typography>

      <Stack gap={4}>
        {detailProduct && detailProduct.inventoryFiles.length > 0 ? (
          detailProduct.inventoryFiles.map((item, index) => {
            return renderItemDocument(item, index);
          })
        ) : (
          <Typography align='center' className={cx('noData')}>
            {t('common_no_data_available', { ns: 'common/base' })}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
};

export default DocumentProductDetail;
